<div class="container-fluid page">
  <div class="page-content shadow position-relative">
    <mat-tab-group>
      <mat-tab label="Transactions List">
        <ng-template matTabContent>
          <div class="px-4">
            <div class="d-flex justify-content-between pt-1 my-1">
              <form
                [formGroup]="filterForm"
                class="mat-form d-flex align-items-center gap-10">
                <app-input-select
                  *appHasPlatformAccess
                  (selectionChange)="applyFilter()"
                  [inputData]="attrConstant.partner"
                  [selectOptions]="partnerList | async"
                  [bindLabel]="'name'"
                  [bindValue]="'partner_id'"
                  [formControlName]="
                    attrConstant.partner.key
                  "></app-input-select>
                <app-input-template
                  (keyup)="applyFilter()"
                  [inputData]="attrConstant.search"
                  [formControlName]="
                    attrConstant.search.key
                  "></app-input-template>
                <app-input-select
                  (selectionChange)="applyFilter()"
                  [inputData]="attrConstant.status"
                  [selectOptions]="transactionStatus"
                  [bindLabel]="'name'"
                  [bindValue]="'value'"
                  [formControlName]="
                    attrConstant.status.key
                  "></app-input-select>
                <mat-form-field appearance="outline">
                  <mat-label>Enter a date range</mat-label>
                  <mat-date-range-input [rangePicker]="picker">
                    <input
                      matStartDate
                      [placeholder]="attrConstant.from_date.placeholder"
                      #dateRangeStart
                      [formControlName]="attrConstant.from_date.key" />
                    <input
                      matEndDate
                      [placeholder]="attrConstant.to_date.key"
                      #dateRangeEnd
                      [formControlName]="attrConstant.to_date.key"
                      (dateChange)="applyFilter()" />
                  </mat-date-range-input>
                  <mat-datepicker-toggle matSuffix [for]="picker">
                  </mat-datepicker-toggle>
                  <mat-date-range-picker
                    #picker
                    [calendarHeaderComponent]="CustomDateRangeHeader">
                  </mat-date-range-picker>
                </mat-form-field>
                <img
                  src="assets/images/clear-filter.svg"
                  class="clear-img"
                  alt="clear-filter"
                  matTooltip="Clear Filters"
                  matTooltipPosition="above"
                  [attr.aria-hidden]="true"
                  (click)="clearFilters()" />
              </form>
              <div class="d-flex align-items-center gap-10">
                <img
                  src="assets/images/reload.svg"
                  alt="reload"
                  class="reload-img"
                  matTooltip="Reload"
                  matTooltipPosition="above"
                  [attr.aria-hidden]="true"
                  (click)="reload()" />
                <button class="btn primary-btn" (click)="export()">
                  Export
                </button>
              </div>
            </div>
            <table
              mat-table
              matSort
              [matSortActive]="activeSort?.active ?? 'created_at'"
              [matSortDirection]="activeSort?.direction ?? 'desc'"
              [dataSource]="dataSource"
              (matSortChange)="onSortChange($event)">
              <!-- Trans Ref Column -->
              <ng-container matColumnDef="trans_session_id">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>
                  Trans Ref
                </th>
                <td mat-cell *matCellDef="let element" data-label="Trans Ref">
                  {{ element.trans_session_id }}
                </td>
              </ng-container>

              <!-- Create Date Column -->
              <ng-container matColumnDef="created_at">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>
                  Create Date
                </th>
                <td mat-cell *matCellDef="let element" data-label="Create Date">
                  {{ element.created_at | date: 'dd/MM/yyyy' }}
                </td>
              </ng-container>

              <!-- Created By Column -->
              <ng-container matColumnDef="created_by">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>
                  Created By
                </th>
                <td mat-cell *matCellDef="let element" data-label="Created By">
                  {{ element.created_by }}
                </td>
              </ng-container>

              <!-- Status Column -->
              <ng-container matColumnDef="transaction_status">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>
                  Status
                </th>
                <td mat-cell *matCellDef="let element" data-label="Status">
                  @if (userInfo?.mode === 'MANUAL') {
                    <span
                      [ngClass]="
                        element.transaction_status === 'Paid'
                          ? 'clr-green'
                          : element.transaction_status === 'Partial Payment'
                            ? 'clr-amber'
                            : element.transaction_status === 'Reject'
                              ? 'clr-red'
                              : element.transaction_status === 'Created'
                                ? 'clr-blue'
                                : ''
                      ">
                      {{ element.transaction_status }}
                    </span>
                  } @else {
                    {{ element.transaction_status }}
                  }
                </td>
              </ng-container>

              <!-- Source Amount Column -->
              <ng-container matColumnDef="source_amount">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>
                  Source Amount
                </th>
                <td
                  mat-cell
                  *matCellDef="let element"
                  data-label="Source Amount">
                  {{ element.source_amount }}
                </td>
              </ng-container>

              <!-- Dest Amount Column -->
              <ng-container matColumnDef="destination_amount">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>
                  Dest Amount
                </th>
                <td mat-cell *matCellDef="let element" data-label="Dest Amount">
                  {{ element.destination_amount }}
                </td>
              </ng-container>

              <!-- sender/ID Column -->
              <ng-container matColumnDef="sender_first_name">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>
                  sender's Name
                </th>
                <td
                  mat-cell
                  *matCellDef="let element"
                  data-label="sender's Name">
                  {{ element.sender_first_name }}
                  {{ element.sender_middle_name }}
                  {{ element.sender_last_name }}
                </td>
              </ng-container>

              <!-- Beneficiary's Name Column -->
              <ng-container matColumnDef="beneficiary_first_name">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>
                  Beneficiary's Name
                </th>
                <td
                  mat-cell
                  *matCellDef="let element"
                  data-label="Beneficiary's Name">
                  {{ element.beneficiary_first_name }}
                  {{ element.beneficiary_middle_name }}
                  {{ element.beneficiary_last_name }}
                </td>
              </ng-container>

              <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
              <tr
                mat-row
                class="custom-mat-btn"
                *matRowDef="let row; columns: displayedColumns; let element"
                [routerLink]="[
                  '/transaction/details',
                  isSuperAdmin
                    ? element.trans_session_id + '-' + element.partner_id
                    : element.trans_session_id,
                ]"></tr>
            </table>
            <mat-paginator
              showFirstLastButtons
              [pageIndex]="page"
              [length]="total"
              [pageSize]="limit"
              [pageSizeOptions]="[10, 20, 50, 100, 200]"
              (page)="onPageChange($event)">
            </mat-paginator>
          </div>
        </ng-template>
      </mat-tab>
      <mat-tab disabled>
        <ng-template mat-tab-label>
          <a
            class="btn primary-btn"
            [routerLink]="['/transaction/create']"
            *appHasAccess="'/transaction/create'">
            Create Offline Transaction
          </a>
          <a
            class="btn primary-btn ms-2"
            [routerLink]="['/transaction/upload']"
            *appHasAccess="'/transaction/upload'">
            Upload Transactions
          </a>
        </ng-template>
      </mat-tab>
    </mat-tab-group>
  </div>
</div>
